/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { EditReimbursementModalButtons } from './EditReimbursementModalButtons';

import { useDirectDepositContent } from './hooks/useDirectDepositContent';

import styles from '../css/CheckContent.module.css';

const CheckContent = ({ onCancel = () => { }, goNext, backupMethod = false }) => {
  const { t } = useTranslation('myAccount');
  const store = useSelector(({ personalInformation }) => ({
    personalInformation,
  }), shallowEqual);
  const { personalInformation: { userInfo } } = store;
  const {
    handleEditReimbursementAccept,
    handleEditReimbursementCancel,
    handleEditReimbursementSuccess,
    reimbursementMethodUpdateSuccess,
    updatingReimbursementMethod,
  } = useDirectDepositContent({ onCancel });

  const addressValue = useMemo(() => `${userInfo.Address.Line1} ${userInfo.Address.Line2 ? `,${userInfo.Address.Line2}` : ''}
    ${userInfo.Address.City}, ${userInfo.Address.StateId} ${userInfo.Address.ZipCode}`,
  [userInfo.Address]);

  return (
    <div>
      <h6 className={styles.contentTitle}>
        {backupMethod
          ? t('reimbursementSection.editModal.checkBackup')
          : t('reimbursementSection.editModal.addressOnFile')}
      </h6>

      {backupMethod && (
        <p className={styles.addressOnFile}>
          {t('reimbursementSection.editModal.addressOnFileBackup')}
        </p>
      )}

      <p className={styles.contentAddress}>{addressValue}</p>

      <p className={styles.contentFooterText}>
        {t('reimbursementSection.editModal.appliedToAllPolicies')}
      </p>

      <EditReimbursementModalButtons
        finalStep
        handleEditReimbursementAccept={goNext || handleEditReimbursementAccept}
        handleEditReimbursementCancel={handleEditReimbursementCancel}
        handleEditReimbursementSuccess={handleEditReimbursementSuccess}
        reimbursementMethodUpdateSuccess={reimbursementMethodUpdateSuccess}
        updatingReimbursementMethod={updatingReimbursementMethod}
      />
    </div>
  );
};

export { CheckContent };
